export default __webpack_public_path__ + "static/media/annex4.7d4f07ea.png";